// Module
var code = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"10.57\" height=\"8\" viewBox=\"0 0 10.57 8\"> <g id=\"noun_41116_cc\" transform=\"translate(-22.3 -28.5)\"> <path id=\"Path_751\" data-name=\"Path 751\" d=\"M32.87,28.5H22.3l4.462,4.65v2.324A1.018,1.018,0,0,0,27.791,36.5h.617V33.15Z\" transform=\"translate(0 0)\" fill=\"#fff\"/> </g> </svg> ";
// Exports
module.exports = code;